import type { Table } from '@wmt/content-blocks'
import type { PlayerRoster } from '~/types'
import type { PlayerStatsCategory } from '~/enums/player-stats-category'
import { RosterPlayerStatsCategories } from '~/enums/player-stats-category'

export type DataType = MaybeRefOrGetter<Maybe<PlayerRoster.Model[] | undefined>>

export type SchemasType = {
  [key in keyof typeof PlayerStatsCategory]: {
    title: string
    schema: Table.TableStructure
    data: DataType
  }
}

export const usePlayerRosterStatistics = (data: DataType) => {
  const playerRosters = ref<PlayerRoster.Model[]>([])

  const schemas = computed<SchemasType>(() => {
    return Object.entries(RosterPlayerStatsCategories).reduce<SchemasType>((result, [title, schema]) => {
      const items = playerRosters.value.filter(schema.filter)

      if (items.length) {
        // @ts-expect-error Need to define the type for the key
        result[title] = {
          title,
          schema: schema.schema,
          data: items,
        }
      }

      return result
    }, {} as SchemasType)
  })

  const hasSchemas = computed<boolean>(() => Object.keys(schemas.value).length > 0)

  watchEffect(() => {
    if (data) {
      playerRosters.value = unref(data) as PlayerRoster.Model[]
    }
  })

  return {
    schemas,
    hasSchemas,
  }
}
